import { defineComponent as y, ref as i, renderSlot as C, unref as l } from "vue";
import { omit as _ } from "lodash-es";
import { useCollapse as g } from "@teamnovu/kit-composables";
import { useVModel as B, syncRef as R } from "@vueuse/core";
import { nanoid as h } from "nanoid";
const V = /* @__PURE__ */ y({
  __name: "Collapse",
  props: {
    open: { type: Boolean },
    dimension: {},
    duration: {},
    transition: {},
    initiallyClosed: { type: Boolean },
    controlled: { type: Boolean }
  },
  emits: ["update:open"],
  setup(a, { emit: r }) {
    const o = a, p = r, s = i(), n = i(!1), u = h(), e = g(s, {
      ..._(o, ["open"]),
      id: u,
      provide: !0,
      initiallyClosed: o.open === void 0 ? o.initiallyClosed : !o.open,
      onStarted: () => {
        n.value = !0;
      },
      onFinished: () => {
        n.value = !1;
      }
    }), c = B(o, "open", p, { passive: !0 });
    R(e, c);
    const d = (t) => {
      s.value = t;
    }, m = () => {
      e.value = !0;
    }, f = () => {
      e.value = !1;
    }, v = () => {
      e.value = !l(e);
    };
    return (t, O) => C(t.$slots, "default", {
      ref: d,
      open: m,
      close: f,
      toggle: v,
      isOpen: l(e),
      isTransitioning: n.value
    });
  }
});
export {
  V as _
};
